import styled from 'styled-components'

import { BREAKPOINT_DESKTOP_PX, PAGE_CONTENT_TOP_MARGIN } from '../global/constants'

export const WizardStepMainContentContainer = styled.div<{
  $isHeaderFixed: boolean | undefined
  $hasSubheader: boolean
  $hasHeaderSectionContent: boolean
}>`
  margin-top: 16px;
  @media (max-width: ${BREAKPOINT_DESKTOP_PX}px) {
    margin-top: ${({ $isHeaderFixed, $hasHeaderSectionContent }) =>
      `${$isHeaderFixed || $hasHeaderSectionContent ? PAGE_CONTENT_TOP_MARGIN : 0}px`};
  }
  display: flex;
  flex-direction: column;
  align-items: center;
`
